import { Form, Input, InputType } from "decorator-form";

@Form({title:"User Preferences Config"})
export default class UserPreferencesConfig {

    @Input({type: InputType.STRING_ARRAY, title:"Tag Set Names"})
    public tagSetNames: string[];
}


// WEBPACK FOOTER //
// ./src/panels/recommended/userPreferences/UserPrerencesConfig.ts